/*
 * Replenishment prompts for logged-in returning shoppers. Reads window.AIReorderData
 * (rendered by snippets/ai-reorder-data.liquid; client-side only). Computes a
 * per-product reorder window from the shopper's own purchase cadence (median
 * interval, clamped 14-90 days; 30-day default for single purchases) and:
 *   - /search page: renders a "Buy it again" row of due products above results
 *   - product pages: renders a "You last ordered this..." banner
 * Measurement: 'prompt' impressions + clicks with item_kind 'reorder' (kept
 * separate from search metrics); reorder->cart attributed via a synthetic 'ro-' id.
 * Fail-soft everywhere; logged-out shoppers: no data -> no-op.
 */
(function () {
  var DEFAULT_WINDOW = 30, MIN_WINDOW = 14, MAX_WINDOW = 90, DUE_AT = 0.75, MAX_PROMPTS = 4;

  function esc(s) {
    return (window.AISearchClient && window.AISearchClient.escapeHtml)
      ? window.AISearchClient.escapeHtml(s)
      : String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
  }
  function track(ev) {
    try { if (window.AISearchAnalytics && window.AISearchAnalytics.track) window.AISearchAnalytics.track(ev); } catch (e) {}
  }

  /** Group purchases by product; score each by days-since-last vs its reorder window. */
  function computeDue(items, nowMs) {
    var by = {};
    (items || []).forEach(function (it) {
      if (!it || !it.handle) return;
      var t = Number(it.purchasedAt) * 1000;
      if (!isFinite(t)) return;
      var g = by[it.handle];
      if (!g) { g = by[it.handle] = { dates: [], it: it, last: 0 }; }
      g.dates.push(t);
      if (t >= g.last) { g.last = t; g.it = it; } // keep latest purchase's metadata
    });
    var now = nowMs || Date.now();
    var out = [];
    Object.keys(by).forEach(function (h) {
      var g = by[h];
      g.dates.sort(function (a, b) { return a - b; });
      var windowDays = DEFAULT_WINDOW;
      if (g.dates.length >= 2) {
        var iv = [];
        for (var i = 1; i < g.dates.length; i++) iv.push((g.dates[i] - g.dates[i - 1]) / 864e5);
        iv.sort(function (a, b) { return a - b; });
        windowDays = Math.min(MAX_WINDOW, Math.max(MIN_WINDOW, Math.round(iv[Math.floor(iv.length / 2)])));
      }
      var daysSince = (now - g.last) / 864e5;
      out.push({
        handle: h, title: g.it.title, url: g.it.url, image: g.it.image, price: g.it.price,
        purchases: g.dates.length, daysSince: Math.round(daysSince), windowDays: windowDays,
        dueScore: daysSince / windowDays,
      });
    });
    out.sort(function (a, b) { return b.dueScore - a.dueScore; });
    return out;
  }
  function dueOnly(all) {
    return all.filter(function (x) { return x.dueScore >= DUE_AT; }).slice(0, MAX_PROMPTS);
  }

  function cardHtml(it, i) {
    var img = it.image ? '<div class="ai-search-card__media"><img src="' + esc(it.image) + '" alt="' + esc(it.title) + '" loading="lazy"></div>' : '';
    var ago = it.daysSince >= 14 ? Math.round(it.daysSince / 7) + ' weeks ago' : it.daysSince + ' days ago';
    return '<li class="grid__item ai-search-card">' +
      '<a class="ai-search-card__link" href="' + esc(it.url) + '" data-ai-reorder data-ai-handle="' + esc(it.handle) + '" data-ai-position="' + i + '">' +
      img + '<div class="ai-search-card__info">' +
      '<span class="ai-search-card__badge">Last ordered ' + esc(ago) + '</span>' +
      '<h3 class="ai-search-card__title h5">' + esc(it.title) + '</h3>' +
      '</div></a></li>';
  }

  function renderSearchRow(due) {
    var container = document.getElementById('ProductGridContainer');
    if (!container || !due.length || document.querySelector('.ai-reorder')) return;
    var html = '<div class="ai-reorder page-width">' +
      '<h3 class="ai-discovery__title">Time to restock? Buy it again</h3>' +
      '<ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop ai-search-grid" role="list">' +
      due.map(function (it, i) { return cardHtml(it, i + 1); }).join('') + '</ul></div>';
    container.insertAdjacentHTML('beforebegin', html);
    track({ event_type: 'prompt', item_kind: 'reorder', surface: 'search', result_count: due.length });
  }

  function renderPdpBanner(all) {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var hit = null;
    for (var i = 0; i < all.length; i++) { if (all[i].handle === m[1]) { hit = all[i]; break; } }
    if (!hit || document.querySelector('.ai-reorder-banner')) return;
    var target = document.querySelector('.product__info-wrapper, .product__info-container');
    if (!target) return;
    var ago = hit.daysSince >= 14 ? Math.round(hit.daysSince / 7) + ' weeks' : hit.daysSince + ' days';
    var msg = 'You last ordered this ' + esc(ago) + ' ago' + (hit.dueScore >= DUE_AT ? ' — time to restock?' : '.');
    target.insertAdjacentHTML('afterbegin', '<div class="ai-reorder-banner">' + msg + '</div>');
    track({ event_type: 'prompt', item_kind: 'reorder', surface: 'pdp', item_id: hit.handle });
  }

  // Click tracking + synthetic cart attribution (kept out of search metrics).
  document.addEventListener('click', function (e) {
    try {
      var a = e.target && e.target.closest ? e.target.closest('[data-ai-reorder]') : null;
      if (!a) return;
      var handle = a.getAttribute('data-ai-handle');
      var roId = 'ro-' + Math.floor(Math.random() * 1e9).toString(36) + Date.now().toString(36);
      if (window.AISearchAnalytics && window.AISearchAnalytics.markSourced) {
        window.AISearchAnalytics.markSourced(handle, roId);
      }
      track({ event_type: 'click', search_id: roId, item_id: handle, item_kind: 'reorder',
              position: Number(a.getAttribute('data-ai-position')) || null, surface: 'search' });
    } catch (err) {}
  }, true);

  function run(data) {
    try {
      var d = data || window.AIReorderData;
      if (!d || !d.items || !d.items.length) return;
      var all = computeDue(d.items);
      if (location.pathname.indexOf('/search') === 0) renderSearchRow(dueOnly(all));
      renderPdpBanner(all);
    } catch (e) {}
  }

  window.AIReorder = { computeDue: computeDue, dueOnly: dueOnly, run: run };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
})();
